import React, { FC, PropsWithChildren } from 'react';
import { Center, Flex, Spinner } from '@chakra-ui/react';

interface Props extends PropsWithChildren {
  show: boolean;
}

export const FeatureFlagWrapper: FC<Props> = ({ show, children }) => {
  return (
    <>
      {!show ? (
        <Flex
          w="100%"
          h="100%"
          minHeight="calc(100vh - 200px)"
          justifyContent="center"
        >
          <Center>
            <Spinner color="orange" width={8} height={8} />
          </Center>
        </Flex>
      ) : (
        children
      )}
    </>
  );
};
